import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React from "react";
import "./index.css";
import App from "./App/App";
import configureStore from "./redux/configureStore";
import { Provider } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import * as Sentry from "@sentry/browser";

var Dashboard = /*#__PURE__*/function (_React$Component) {
  _inherits(Dashboard, _React$Component);

  var _super = _createSuper(Dashboard);

  function Dashboard(props) {
    var _this;

    _classCallCheck(this, Dashboard);

    _this = _super.call(this, props);

    var _configureStore = configureStore(),
        store = _configureStore.store,
        history = _configureStore.history;

    _this.state = {
      store: store,
      history: history
    };

    if (typeof props.profileConfig.sentry_dsn !== "undefined" && process.env.NODE_ENV !== "development") {
      Sentry.init({
        dsn: props.profileConfig.sentry_dsn
      });
    }

    return _this;
  }

  _createClass(Dashboard, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      Sentry.withScope(function (scope) {
        Object.keys(errorInfo).forEach(function (key) {
          scope.setExtra(key, errorInfo[key]);
        });
        Sentry.captureException(error);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Provider, {
        store: this.state.store
      }, /*#__PURE__*/React.createElement(App, Object.assign({
        history: this.state.history
      }, this.props, {
        replaceReducer: this.state.store.replaceReducer
      })));
    }
  }]);

  return Dashboard;
}(React.Component);

export default Dashboard;